export enum SettingsTab {

    Funds = "funds",
    Profile = "profile",
    Legal = "legal"
}
